import React, { useState, useRef } from "react";
import { FaCaretRight, FaCaretLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom"; // Assuming you're using react-router-dom for navigation
import { useDispatch, batch } from "react-redux";
import {
  deleteTemporaryFilters,
  setWorkbookProperty,
} from "../../reduxworkbook/WorkbookSlice";
import { deleteSheetControls } from "../../reduxworkbook/WorkbookControllingSlice";

function ViewworkbookHeader2({ workbookData, workbookId, sheetId, isEmbed }) {
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const scrollableDivRef = useRef(null);
  const navigate = useNavigate(); // For URL navigation

  const scrollLeftt = () => {
    scrollableDivRef.current.scrollBy({
      left: -100, // Adjust the number for the scroll distance
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    scrollableDivRef.current.scrollBy({
      left: 100, // Adjust the number for the scroll distance
      behavior: "smooth",
    });
  };

  const startScrolling = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollableDivRef.current.offsetLeft);
    setScrollLeft(scrollableDivRef.current.scrollLeft);
  };

  const scrolling = (e) => {
    if (!isDragging) return;
    e.preventDefault(); // Prevent text selection
    const x = e.pageX - scrollableDivRef.current.offsetLeft;
    const walk = (x - startX) * 2; // Adjust scroll speed as needed
    scrollableDivRef.current.scrollLeft = scrollLeft - walk; // Update scroll position
  };

  const stopScrolling = () => {
    setIsDragging(false);
  };

  const dispatch = useDispatch();

  // const handleSheetChange = (index) => {
  //   console.log("sheet change");

  //   const { ID: sheetId } = workbookData.sheets[index];
  //   // console.log(sheetId);
  //   // dispatch(
  //   //   deleteTemporaryFilters({
  //   //     sourceSheet: null,
  //   //     allTempFiltersBoolean: true,
  //   //   })
  //   // );
  //   // dispatch(deleteSheetControls());
  //   // dispatch(
  //   //   setWorkbookProperty({
  //   //     itemInArray: false,
  //   //     key: "selectedSheetId",
  //   //     value: sheetId,
  //   //   })
  //   // );
  //   // Update the URL with the selected sheetid
  //   // console.log(workbookId);
  //   // console.log(sheetId);

  //   batch(() => {
  //     dispatch(
  //       deleteTemporaryFilters({
  //         sourceSheet: null,
  //         allTempFiltersBoolean: true,
  //       })
  //     );
  //     dispatch(deleteSheetControls());
  //     dispatch(
  //       setWorkbookProperty({
  //         itemInArray: false,
  //         key: "selectedSheetId",
  //         value: sheetId,
  //       })
  //     );
  //   });

  //   if (isEmbed) {
  //     navigate(
  //       `/dashboard?workbookid=${workbookId}&sheetid=${sheetId}&isEmbed=true`
  //     );
  //   } else {
  //     console.log("navigating");

  //     navigate(`/dashboard?workbookid=${workbookId}&sheetid=${sheetId}`);
  //   }
  // };

  const handleSheetChange = (index) => {
  const { ID: sheetId } = workbookData.sheets[index];

  const newUrl = isEmbed
    ? `/dashboard?workbookid=${workbookId}&sheetid=${sheetId}&isEmbed=true`
    : `/dashboard?workbookid=${workbookId}&sheetid=${sheetId}`;

    console.log("navigating");
    
  // Navigate first to trigger unmount of old sheet
  navigate(newUrl);

  // After navigation tick, safely reset redux states in one batch
  // setTimeout(() => {
  //   batch(() => {
  //     dispatch(
  //       deleteTemporaryFilters({
  //         sourceSheet: null,
  //         allTempFiltersBoolean: true,
  //       })
  //     );
  //     dispatch(deleteSheetControls());
  //     dispatch(
  //       setWorkbookProperty({
  //         itemInArray: false,
  //         key: "selectedSheetId",
  //         value: sheetId,
  //       })
  //     );
  //   });
  // }, 200);
};



  // // console.log(workbookData.sheets);

  return (
    <aside className="flex border-black rounded w-full items-center justify-between bg-gray-200 overflow-hidden px-[1px] h-[3%]">
      <button
        className="bg-transparent text-blue-950 border-r border-gray-400 flex items-center justify-center h-full"
        onClick={scrollLeftt}
      >
        <FaCaretLeft className="text-sm" />
      </button>

      {/* Wrapper for the scrollable area */}
      <div
        id="scrollableDiv"
        className="w-full flex justify-start items-center h-full"
        style={{ overflowX: "hidden", whiteSpace: "nowrap" }}
        ref={scrollableDivRef}
        onMouseDown={startScrolling}
        onMouseMove={scrolling}
        onMouseUp={stopScrolling}
        onMouseLeave={stopScrolling}
      >
        {workbookData.sheets.map(
          (sheet, index) =>
            sheet.isSheetVisible && (
              <button
                key={index}
                className={`text-xs tracking-wide p-1 ${
                  sheet.ID === sheetId
                    ? "bg-white text-black font-[500]"
                    : "bg-gray-200 text-black font-[300]"
                } border-r border-gray-400 h-full`}
                onClick={() => handleSheetChange(index)}
              >
                {sheet.SheetName}
              </button>
            )
        )}
      </div>

      <button
        className="bg-transparent text-blue-950 border-l border-gray-400 flex items-center justify-center h-full"
        onClick={scrollRight}
      >
        <FaCaretRight className="text-sm" />
      </button>
    </aside>
  );
}

export default ViewworkbookHeader2;
